import estiloJuegos from "../../../../../../theme/Juegos.module.css";
import style from "../../../../../../theme/programas/calculo/Game1.module.css";

import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";

import { test_general } from "../../../../../../datos/DatosTests";
import { nomProgSumas1 } from "../../../../../../datos/nombresBD";
import { useDato } from "../../../../../../modelos/auth";
import {
  newActivity,
  changePrograma,
  changeCondicion,
} from "../../../../../../redux/actividad/reducerActividad";
import { sumaNeuronas } from "../../../../../../redux/auth/reducerAuth";
import {
  terminadoJuego,
  changePuntaje,
} from "../../../../../../redux/juegoSimultaneo/reducerJuegoSimultaneo";
import { useAppSelector, useAppDispatch } from "../../../../../../redux/store";
import { useJuegos } from "../../../../../../repositorio/controlador/useJuegos";
import DosBotonesColumna from "../../../../../components/DosBotonesColumna";
import Selector from "../../../../../components/Selector";
import { obtenerNeuronas } from "../../../../../utils/neuronasUtil";
import PartidaSumas from "./juegoSumas/components/PartidaSumas";
import Loading from "../../../../../components/Loading";
import ProgressBar from "../../componentes/ProgressBar";


const JuegoSumas = () => {
  const userId = useAppSelector((state) => state.auth.userId);

  const esJuego = useAppSelector((state) => state.activity.id === test_general);
  const idActividad = useAppSelector((state) => state.activity.id);
  const esEntrenamiento = useAppSelector(
    (state) => state.activity.name === "entrenamiento"
  );
  const idEntrenamiento = useAppSelector(
    (state) => state.entrenamiento.current_entrenamiento?.id
  );

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { GuardarRegistroSumas, getCalificacionGeneral } = useJuegos();
  const { state } = useDato();

  const titulo = "Sumas de un digitoo";
  const MAXPARTIDAS = 5;
  const NIVELINICIAL = 6;
  const NIVEL_MINIMO = 1;
  // Escalera adaptativa: el paso es un % del nivel actual, decreciente por
  // intento. Pasos grandes al inicio ubican rapido el techo real del
  // jugador; pasos chicos al final estabilizan el nivel en vez de dispararlo
  // (el sistema anterior multiplicaba el paso x1.5 en cada racha sin techo,
  // y en 4-5 aciertos seguidos volvia el juego literalmente injugable).
  const PASOS_NIVEL = [0.5, 0.35, 0.25, 0.15, 0.10];

  // Puntaje de torneo: cada ronda aporta nivel x precision x velocidad;
  // la suma de las 5 rondas se escala para dar un entero grande (no un
  // decimal chico) con suficiente resolucion para que 200 jugadores casi
  // nunca empaten.
  const TIEMPO_BASE_MS = 2000;
  const TIEMPO_POR_NUMERO_MS = 600;
  const VELOCIDAD_MIN = 0.7;
  const VELOCIDAD_MAX = 1.3;
  const ESCALA_PUNTAJE = 100;

  const arregloNumeros = Array.from({ length: 50 }, (_, index) => ({
    value: index + 1,
    name: index + 1,
  }));

  // acumuladores de la sesión (modo entrenamiento: economia de neuronas, sin cambios)
  const sumaTotal = useRef<number>(0);
  const diferenciaTotal = useRef<number>(0);

  // acumulador del puntaje de torneo (nivel x precision x velocidad por ronda)
  const puntajeTorneo = useRef<number>(0);

  // anti-doble-acreditación
  const awardedRef = useRef<boolean>(false);

  const [estado, setEstado] = useState<number>(0);
  const [partida, setPartida] = useState<number>(0);
  const [nivel, setNivel] = useState<number>(NIVELINICIAL);
  const [nivelGanado, setNivelGanado] = useState<number>(1);
  const [puntaje, setPuntaje] = useState<number>(0);
  const [cargado, setCargado] = useState<boolean>(false);
  const [nivelSeleccionado, setNivelSeleccionado] = useState<number | null>(
    null
  );

  const seleccionarNivel = (nuevoNivel: number) => {
    setNivelSeleccionado(nuevoNivel);
    setNivel(nuevoNivel);
  };

  const calcularPuntajeBase = () => {
    // obtenerNeuronas(nomProgSumas1, correctas, errores) => mínimo 1
    const base = obtenerNeuronas(nomProgSumas1, sumaTotal.current, diferenciaTotal.current);
    return Math.max(1, Math.round(base));
  };

  const clamp = (valor: number, minimo: number, maximo: number) =>
    Math.min(maximo, Math.max(minimo, valor));

  const getNuevoNivel = (intentoIndex: number, acerto: boolean) => {
    const porcentaje = PASOS_NIVEL[clamp(intentoIndex, 0, PASOS_NIVEL.length - 1)];
    const paso = nivel * porcentaje;
    const nuevoNivel = acerto ? nivel + paso : nivel - paso;
    return Math.max(NIVEL_MINIMO, nuevoNivel);
  };

  // Puntaje de una ronda: recompensa el nivel alcanzado, que tan cerca
  // estuvo de la respuesta correcta (no solo si acerto o no) y que tan
  // rapido respondio en relacion a lo esperado para esa cantidad de numeros.
  const getPuntajeRonda = (
    nivelRonda: number,
    diferencia: number,
    suma: number,
    tiempoRespuestaMs: number,
    cantidadNumeros: number
  ) => {
    const precision = suma > 0 ? clamp(1 - diferencia / suma, 0, 1) : 0;
    const tiempoEsperadoMs = TIEMPO_BASE_MS + cantidadNumeros * TIEMPO_POR_NUMERO_MS;
    const velocidad = clamp(tiempoEsperadoMs / Math.max(tiempoRespuestaMs, 1), VELOCIDAD_MIN, VELOCIDAD_MAX);
    return nivelRonda * precision * velocidad;
  };

  // ---------- CÁLCULO Y ACREDITACIÓN ÚNICA ----------
  const acreditarUnaVez = (nivelGuardado: number) => {
    if (awardedRef.current) return;
    awardedRef.current = true;

    if (idActividad !== "juego_linea") {
      // Modo entrenamiento: economia de neuronas sin cambios.
      const neuronasBase = calcularPuntajeBase(); // ya redondeado y mínimo 1
      setPuntaje(neuronasBase);
      GuardarRegistroSumas(
        userId,
        { puntaje: neuronasBase, nivel: Math.round(nivelGuardado), puntajeRaw: neuronasBase },
        state.nombres,
        state.pais
      );
      dispatch(sumaNeuronas({ cantidad: neuronasBase }));
    } else {
      // Torneo: puntaje de las 5 rondas (nivel x precision x velocidad), escalado a entero.
      const puntajeFinal = Math.max(1, Math.round(puntajeTorneo.current * ESCALA_PUNTAJE));
      setPuntaje(puntajeFinal);
      dispatch(
        terminadoJuego({
          ultimoResultado: puntajeFinal,
          tiempo: 0,
          finalizado: true,
        })
      );
    }
  };


  async function HandleBackButtonClick(): Promise<void> {
    // si ya completó las partidas, acredita solo una vez antes de salir
    if (partida >= MAXPARTIDAS) {
      acreditarUnaVez(nivel);
    }

    if (esEntrenamiento) {
      await dispatch(
        newActivity({ id: idEntrenamiento, name: "entrenamiento" })
      );
      await dispatch(changePrograma({ id: idEntrenamiento }));
      dispatch(changeCondicion({ condicion: 10 }));
      navigate(-2);
    } else {
      if (idActividad === "juego_linea") {
        dispatch(changePuntaje({ verPuntaje: true }));
      } else {
        navigate(-1);
      }
    }
  }

  // ---------- FLUJO ----------
  const Constructor = () => {
    if (
      idActividad !== "juego_linea" &&
      nivelSeleccionado === null &&
      partida === 0
    ) {
      getCalificacionGeneral(userId, nomProgSumas1).then((calificacion) => {
        if (calificacion && calificacion.nivel) {
          setNivel(calificacion.nivel);
          setNivelGanado(calificacion.nivel);
        } else {
          setNivel(6);
          setNivelGanado(1);
        }
        setCargado(true);
      });
    } else {
      setCargado(true);
    }
  };

  const HandlePlay = () => {
    awardedRef.current = false; // nueva sesión
    sumaTotal.current = 0;
    diferenciaTotal.current = 0;
    puntajeTorneo.current = 0;
    setEstado(1);
  };

  const onReinicio = (diferencia: number, suma: number, tiempoRespuestaMs: number, cantidadNumeros: number) => {
    // Economia de neuronas (modo entrenamiento): sin cambios.
    sumaTotal.current += suma;
    diferenciaTotal.current += diferencia;

    // nivel: escalera adaptativa (paso decreciente por intento, ver PASOS_NIVEL).
    const nivelRonda = nivel; // nivel con el que se jugo esta ronda, antes de actualizarlo
    const acerto = diferencia === 0;
    const nuevoNivel = getNuevoNivel(partida, acerto);
    if (nivelSeleccionado === null) {
      setNivel(nuevoNivel);
      if (nuevoNivel > nivelGanado) setNivelGanado(nuevoNivel);
    }

    // puntaje de torneo: acumula nivel x precision x velocidad de esta ronda.
    puntajeTorneo.current += getPuntajeRonda(nivelRonda, diferencia, suma, tiempoRespuestaMs, cantidadNumeros);

    // ✅ Mostrar el puntaje final en pantalla (sin acreditar) cuando llegamos a 5/5
    if (partida + 1 >= MAXPARTIDAS) {
      const puntajeFinal =
        idActividad === "juego_linea"
          ? Math.max(1, Math.round(puntajeTorneo.current * ESCALA_PUNTAJE))
          : calcularPuntajeBase();
      setPuntaje(puntajeFinal); // esto hace que "Tu Puntaje: X" ya no sea 0
    }

    setPartida((prev) => prev + 1);
    setEstado(2);
  };


  const onSiguiente = () => {
    if (partida >= MAXPARTIDAS) {
      // acredita solo una vez al finalizar
      acreditarUnaVez(nivel);

      if (idActividad === "juego_linea") HandleBackButtonClick();

      // reset locales para volver a jugar
      sumaTotal.current = 0;
      diferenciaTotal.current = 0;
      puntajeTorneo.current = 0;
      setPartida(0);
      setEstado(0);
      awardedRef.current = false; // listo para una nueva sesión
    } else {
      setEstado(1);
    }
  };

  useEffect(() => {
    Constructor();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state._usuarioDato.correo]);

  return (
    <div
      id="page"
      style={idActividad === "juego_linea" ? { height: "100%" } : {}}
    >
      {(idActividad !== "juego_linea" || estado === 0) && (
        <div
          className={
            estado === 0
              ? estiloJuegos.toolbarCalculoMatematico
              : estiloJuegos.toolbar_default
          }
        >
          {esJuego && (
            <div
              className={estiloJuegos.backJuegos}
              onClick={HandleBackButtonClick}
            ></div>
          )}
          <h1
            className={`title ${estiloJuegos.tituloJuegos}`}
            style={estado !== 0 ? { fontSize: "1.25rem" } : {}}
          >
            {titulo}
          </h1>
        </div>
      )}

      {estado === 0 && (
        <div className={estiloJuegos.contenedorIconoMatematico}>
          <img
            src="/assets/componentes/Juegos/CÁLCULO MATEMÁTICO.svg"
            className={estiloJuegos.icono}
            alt="Ícono de cálculo matemático"
          />
        </div>
      )}

      <div id="content_default" style={{ maxHeight: "84svh" }}>
        {estado === 0 && (
          <div className={estiloJuegos.primeraPantalla}>
            <div
              className={estiloJuegos.descripcionJuego}
              style={{ margin: "auto" }}
            >
              Suma en tiempo real cada número que aparezca.
            </div>

            {(state._usuarioDato.correo === "showsupercerebros@gmail.com" ||
              state._usuarioDato.correo === "juanpabloduque@gmail.com") && (
                <div>
                  <Selector
                    setSelection={seleccionarNivel}
                    selection={nivel}
                    style_contain={{
                      border: "1px solid var(--color-Pink-Light)",
                    }}
                    opciones={arregloNumeros}
                  />
                </div>
              )}

            <button
              className={estiloJuegos.buttonEmpezar}
              style={{ margin: "auto" }}
              onClick={HandlePlay}
            >
              EMPEZAR
            </button>

            {esJuego && (
              <button
                id="button_bordes_default"
                onClick={() => navigate("/my/juegos/ranking")}
              >
                RANKING
              </button>
            )}
          </div>
        )}

        {estado === 1 && !cargado && <Loading isOpen={true} />}

        {estado > 0 && estado <= 2 && (
          <ProgressBar tamaño={MAXPARTIDAS} posicion={partida} />
        )}

        {cargado && (
          <PartidaSumas estado={estado} nivel={nivel} onReinicio={onReinicio} />
        )}

        {estado === 2 && (
          <>
            {partida >= MAXPARTIDAS && (
              <p className={style.subMensaje} style={{ fontSize: "3svh" }}>
                Tu Puntaje: <span>{puntaje}</span>
              </p>
            )}

            {idActividad === "juego_linea" ? (
              <button
                className={estiloJuegos.buttonEmpezar}
                style={{ width: "95%" }}
                onClick={onSiguiente}
              >
                {partida >= MAXPARTIDAS ? "FINALIZAR" : "SIGUIENTE"}
              </button>
            ) : (
              <DosBotonesColumna
                textoSuperior={
                  partida < MAXPARTIDAS ? "SIGUIENTE" : "JUGAR DE NUEVO"
                }
                textoInferior={
                  esJuego
                    ? "VOLVER"
                    : partida < MAXPARTIDAS
                      ? "RENDIRSE"
                      : "FINALIZAR"
                }
                onClickSuperior={onSiguiente}
                onClickInferior={HandleBackButtonClick}
                style={{ width: "80%", margin: "3svh 0 4svh 0" }}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default JuegoSumas;
